import { lazy } from "react";
import {
  BarChart3,
  CalendarDays,
  HelpCircle,
  Handshake,
  LayoutDashboard,
  MapPin,
  MessagesSquare,
  Music2,
  Newspaper,
  Package,
  Radio,
  Shield,
  Store,
  Tags,
  Trophy,
  Users,
} from "lucide-react";

/**
 * Fonte única das rotas privadas: o roteador e o menu lateral leem daqui.
 * Cada tela é carregada sob demanda (code splitting).
 */
export const NAV = [
  {
    items: [{ path: "/", label: "Visão geral", icon: LayoutDashboard, page: lazy(() => import("./pages/Dashboard")) }],
  },
  {
    label: "Conteúdo",
    items: [
      { path: "/noticias", label: "Notícias", icon: Newspaper, page: lazy(() => import("./pages/Noticias")) },
      { path: "/cantos", label: "Cantos e hinos", icon: Music2, page: lazy(() => import("./pages/Cantos")) },
      { path: "/parceiros", label: "Parceiros", icon: Handshake, page: lazy(() => import("./pages/Parceiros")) },
    ],
  },
  {
    label: "Futebol",
    items: [
      { path: "/partidas", label: "Partidas", icon: CalendarDays, page: lazy(() => import("./pages/Partidas")) },
      { path: "/placar", label: "Placar ao vivo", icon: Radio, page: lazy(() => import("./pages/Placar")) },
      { path: "/tabela", label: "Classificação", icon: BarChart3, page: lazy(() => import("./pages/Tabela")) },
      { path: "/estadios", label: "Estádios", icon: MapPin, page: lazy(() => import("./pages/Estadios")) },
      { path: "/confrontos", label: "Confrontos", icon: Shield, page: lazy(() => import("./pages/Confrontos")) },
    ],
  },
  {
    label: "Jogos do app",
    items: [
      { path: "/bolao", label: "Bolão", icon: Trophy, page: lazy(() => import("./pages/Bolao")) },
      { path: "/quiz", label: "Quiz", icon: HelpCircle, page: lazy(() => import("./pages/Quiz")) },
    ],
  },
  {
    label: "Loja da Nação",
    items: [
      { path: "/produtos", label: "Produtos", icon: Package, page: lazy(() => import("./pages/Produtos")) },
      { path: "/categorias", label: "Categorias", icon: Tags, page: lazy(() => import("./pages/Categorias")) },
      { path: "/lojas", label: "Lojas", icon: Store, page: lazy(() => import("./pages/Lojas")) },
    ],
  },
  {
    label: "Comunidade",
    items: [
      { path: "/usuarios", label: "Usuários", icon: Users, page: lazy(() => import("./pages/Usuarios")) },
      { path: "/chat", label: "Chat", icon: MessagesSquare, page: lazy(() => import("./pages/Chat")) },
    ],
  },
];

export const ROUTES = NAV.flatMap((g) => g.items);

/** Endereços antigos que podem estar salvos nos favoritos. */
export const REDIRECTS = {
  "/cadastro": "/produtos",
  "/categoria": "/categorias",
  "/cadastrar-categoria": "/categorias",
  "/cadastrar-loja": "/lojas",
  "/gerenciar-placar": "/placar",
  "/TabelaCampeonato": "/tabela",
  "/RankinBolao": "/bolao",
  "/Quiz": "/quiz",
};
